import {Modal} from "react-bootstrap";
import React, {FC} from "react";

interface ModalUnderAgeProps {
  showUnder13: boolean,
}

const ModalUnderAge: FC<ModalUnderAgeProps> = ({showUnder13}) => {
  return (
    <Modal className="modal-signup" show={showUnder13} size="lg"
           aria-labelledby="contained-modal-title-vcenter"
           centered
    >
      <Modal.Header>
        <Modal.Title>
          <h4 className="text-center">Welcome to Villa!</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col py-2">
            <h6>
              To create an account on Villa you must be over the age of 13.
            </h6>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalUnderAge;
